import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import createStore from './Boots/createStore';
import App from './Boots/App';
import TokenService from './Services/TokenService';
import { authSetIsAuthenticated } from './Reducers/auth';
import './index.css';

const store = createStore({});

if (TokenService.hasToken()) {
  store.dispatch(authSetIsAuthenticated(true));
}

TokenService.subscribe(function(isAuthenticated) {
  store.dispatch(authSetIsAuthenticated(isAuthenticated));
});

const AppRouter = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<AppRouter/>);
